module.exports = __webpack_public_path__ + "static/media/ENTP.e5d3ab11.png";